import React from "react";
import { useDispatch } from "react-redux";
import { ValidationField } from "../../../../../models";
import { Form } from "../../../forms";
import { onChangedValue, onRemoveInput, validateForm } from "../../state/actions";
import "./RapidForm.less";

interface RapidFormProps {
    action: string;
    children: React.ReactNode;
    errors: ValidationField;
    id: string;
    method?: string;
    onSubmit: () => void;
    started?: ValidationField;
    values: ValidationField;
    visible: ValidationField;
}

const RapidForm: React.FC<RapidFormProps> = ({
    id,
    action,
    method,
    errors,
    values,
    visible,
    started,
    children,
    onSubmit,
}) => {
    const dispatch = useDispatch();
    return (
        <Form
            id={id}
            className="rapidform"
            action={action}
            method={method}
            errors={errors}
            values={values}
            visible={visible}
            started={started}
            onChangedValue={(name, inputValue, previousValue, shouldValidate, isVisible) =>
                dispatch(onChangedValue(id, name, inputValue, previousValue, shouldValidate, isVisible))
            }
            onRemoveInput={(inputName) => dispatch(onRemoveInput(id, inputName))}
            onSubmit={(e) => dispatch(validateForm(e, id, values, visible, onSubmit))}
        >
            {children}
        </Form>
    );
};

export default RapidForm;
